import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import moment from 'moment';
import PolicyLandingUtil from 'edge/gateway/util/policylanding/PolicyLandingUtil';
import JobUtil from 'edge/gateway/util/JobUtil';

var fn = function fn($filter, $scope, $state, $stateParams, $window, ModalService, AccountService, PolicyService, TranslateService, GPA_PC_ENTRY_POINT, gatewayParamConfig, $q, SearchService) {
    var ctrl = Object.create(BaseCtrl);
    var allAccountJobs = 0;
    var allPolicyFilterJobs = 0;

    init();
    function initQueryOptions() {
        $scope.queryOptions = {
            offsetStart: 0,
            offsetEnd: $scope.pageSize - 1,
            orderBy: 'CreateTime',
            orderByDescending: false
        };
    }

    function init() {
        initQueryOptions();
        $scope.selectedProducerCode = {};
        $scope.loadingComplete = false;
        $scope.recentlyViewedLoading = true;
        $scope.recentlyIssuedLoading = true;
        $scope.jobsLoading = true;
        $scope.showAdvancedFilter = false;
        $scope.jobsCreatedInLastXDays = gatewayParamConfig.jobsCreatedInLastXDays;
        $scope.policiesCreatedInLastXDays = gatewayParamConfig.policiesCreatedInLastXDays;
        $scope.pageSize = gatewayParamConfig.policyLandingResultsPerPage; //25 items per page_MSF
        $scope.jobUtil = JobUtil;
        $scope.numberOfOpenCancellations = 0;

        $scope.tableTitle = function () {
            if ($scope.currentQuickFilter != undefined) {
                if ($scope.currentQuickFilter.displayValue == 'Open Renewals') {
                    return $filter('translate')('gateway.views.policy-landing.Open Renewals days');
                }
                if ($scope.currentQuickFilter.displayValue == 'Open Quotes') {
                    return $filter('translate')('gateway.views.policy-landing.Open Quotes days');
                }
                if ($scope.currentQuickFilter.displayValue == 'Open Changes') {
                    return $filter('translate')('gateway.views.policy-landing.Open Changes days');
                }
            }
            if ($scope.customsFilter != undefined) {
                if ($scope.customsFilter.displayValue == 'Renewal') {
                    return $filter('translate')('gateway.views.policy-landing.Open Renewals days');
                }
                if ($scope.customsFilter.displayValue == 'Quotes') {
                    return $filter('translate')('gateway.views.policy-landing.Open Quotes days');
                }
                if ($scope.customsFilter.displayValue == 'Change') {
                    return $filter('translate')('gateway.views.policy-landing.Open Changes days');
                }
            }
        };

        $scope.openJobInXCenter = function (jobNumber) {
            JobUtil.openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
        };

        PolicyLandingUtil.initializeCustomFilters($scope);
        PolicyLandingUtil.initializeQuickFilters($scope);
        PolicyLandingUtil.translateFilters($scope, translateObjectDisplayKeys);
        PolicyLandingUtil.setInitialQuickFilter($scope, $stateParams.quickFilter);

        getRecentlyViewedPolicies().then(function (policies) {
            $scope.recentlyViewedPolicies = getPolicySummaries(policies);
            $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
            $scope.recentlyViewedLoading = false;
        }, function () {
            $scope.recentlyViewedLoading = false;
        });

        getRecentlyIssuedPolicies(gatewayParamConfig.policiesCreatedInLastXDays).then(function (policies) {
            $scope.recentlyIssuedPolicies = getPolicySummaries(policies);
            $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
            $scope.recentlyIssuedLoading = false;
        }, function () {
            $scope.recentlyIssuedLoading = false;
        });
    } // ** END init()

    // FILTER FUNCTIONS

    /**
     * Filter the policies visible to the user
     * @param {Object} filter - the current quick filter
     * @param {Object} customFilter - the current custom filter
     */
    $scope.filterPolicies = function (filter, customFilter) {
        if (filter) {
            $scope.currentQuickFilter = filter;
        }
        if (customFilter) {
            setCustomFilter(customFilter);
            setCustomFilterFieldsForQuickFilter(filter);
        }
        setActiveQuickFilter();
        //$scope.filteredPolicies = []; // reset filtered policies while loading_commented_MSF
        if (!angular.isDefined($scope.allDelinquentPolicies) && (filter && filter === $scope.delinquentPoliciesFilter || $scope.showAdvancedFilter && customFilter === $scope.policyFilter)) {
            $scope.loadingDelinquentPolicies = true;
            getPolicySummariesForCurrentUser(gatewayParamConfig.policiesCreatedInLastXDays).then(function (summaries) {
                $scope.allDelinquentPolicies = getPolicySummaries(_.where(summaries, {
                    delinquent: true
                }));
                $scope.numberOfDelinquentPolicies = _.filter($scope.allDelinquentPolicies, filterPolicyByProducerCode).length;
                filterAllPolicies();
                $scope.loadingDelinquentPolicies = false;
                $scope.$broadcast('customFilterSelected');
            }, function () {
                $scope.loadingDelinquentPolicies = false;
            });
        } else {
            filterAllPolicies();
        }
        $scope.$broadcast('customFilterSelected');
    };

    function filterAllPolicies() {
        var allPolicies = [];

        if ($scope.currentQuickFilter === $scope.recentlyViewedFilter) {
            allPolicies = $scope.recentlyViewedPolicies;
        } else if ($scope.currentQuickFilter === $scope.recentlyIssuedFilter) {
            allPolicies = $scope.recentlyIssuedPolicies;
        } else if ($scope.currentQuickFilter === $scope.delinquentPoliciesFilter) {
            allPolicies = $scope.allDelinquentPolicies;
        } else if (angular.isDefined($scope.recentlyViewedPolicies)) {
            var uniquePolicies = $scope.allDelinquentPolicies ? $scope.allDelinquentPolicies.concat($scope.recentlyIssuedPolicies, $scope.recentlyViewedPolicies) : $scope.recentlyViewedPolicies.concat($scope.recentlyIssuedPolicies);
            allPolicies = _.uniq(uniquePolicies, false, function (policy) {
                return policy ? policy.policyNumber : null;
            });
        }

        if ($scope.selectedProducerCode) {
            allPolicies = $filter('filter')(allPolicies, filterPolicyByProducerCode);
            if (angular.isDefined(allPolicies)) {
                $scope.numberOfPoliciesForProducerCode = allPolicies.length;
            }
            if (angular.isDefined($scope.allDelinquentPolicies)) {
                $scope.numberOfDelinquentPolicies = _.filter($scope.allDelinquentPolicies, filterPolicyByProducerCode).length;
            }
        }
        $scope.filteredPolicies = $filter('filter')(allPolicies, filterByLineOfBusiness);

        $scope.filteredPolicies = $filter('filter')($scope.filteredPolicies, filterPolicy);
        if ($scope.filteredPolicies) {
            $scope.numberOfPoliciesForProducerCode = $scope.filteredPolicies.length;
        }
    }

    /**
     * Filter a policy based on the current custom filter options
     * @param {Object} [policy]
     * @returns {boolean} true if the possible should be shown, otherwise false
     */
    function filterPolicy(policy) {
        var shouldFilterPolicy = true;
        var customFilter = $scope.customFilter.filter;
        if (angular.isDefined(policy) && customFilter === $scope.policyFilter && checkFilterHasOptionsSelected(customFilter)) {
            for (var i = 0; i < customFilter.filters.length; i++) {
                var filter = customFilter.filters[i];
                var selectedOptions = _.where(filter.options, {
                    selected: true
                });

                if (selectedOptions.length > 0 && filter === $scope.billingStatusFilter) {
                    shouldFilterPolicy = policy.delinquent && _.where(selectedOptions, {
                        code: 'delinquent'
                    }).length > 0 || !policy.delinquent && _.where(selectedOptions, {
                        code: 'inGoodStanding'
                    }).length > 0;
                } else if (selectedOptions.length > 0 && filter === $scope.policyStatusFilter) {
                    shouldFilterPolicy = _.where(selectedOptions, {
                        code: policy.displayStatus
                    }).length > 0;
                }

                if (!shouldFilterPolicy) {
                    break;
                }
            }
        }

        return shouldFilterPolicy;
    }

    /**
     * Filter all the jobs visible to the current user
     * @param {Object} [filter] - the current quick filter
     * @param {Object} [customFilter] - the current custom filter
     */
    $scope.policyFilterPageTitle = function () {
        var policyPageTitle = '';
        if ($scope.showAdvancedFilter) {
            policyPageTitle = $scope.customFilter.filter.displayValue;
        }
        if ($scope.recentlyViewedFilterActive) {
            policyPageTitle = $filter('translate')('gateway.views.policy-landing.Recently Viewed Policies');
        }
        if ($scope.recentlyIssuedFilterActive) {
            policyPageTitle = $filter('translate')('gateway.views.Recently Issued Policies for past 30 days');
        }
        if ($scope.delinquentPoliciesFilterActive) {
            policyPageTitle = $filter('translate')('gateway.views.policy-landing.Delinquent Policies');
        }
        return policyPageTitle;
    };

    function updatePolicyFilterData() {

        return getPolicySummariesForCurrentUserForPage().then(function (accounts) {
            if ($scope.filteredPolicies != undefined) {
                $scope.allPolicyData = $scope.filteredPolicies.slice($scope.queryOptions.offsetStartForPolicyFilter, $scope.queryOptions.offsetEndForPolicyFilter + 1);
                return {
                    'items': $scope.allPolicyData,
                    'maxNumberOfResults': $scope.filteredPolicies.length
                };
            }
        }, function () {});
    }

    function getAccountJobsSummaryForCurrentUser() {
        if (!("all" === $scope.selectedProducerCode.code || "myWork" === $scope.selectedProducerCode.code)) {
            return AccountService.getAccountJobsSummariesForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays, $scope.selectedProducerCode.code);
        }
        return AccountService.getAccountJobsSummariesForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays, undefined);
    }

    function updateQuotesData(filterParam) {

        return getAccountJobsForCurrentUser(filterParam).then(function (accounts) {
            $scope.allJobs = getAllJobs(accounts);
            $scope.jobsLoading = false;
            return {
                'items': $scope.allJobs
            };
        }, function () {
            $scope.jobsLoading = false;
        });
    }

    var _getLoadByOffset = _.memoize(function () {
        return function (offsetStart, offsetEnd, filterParam) {
            $scope.queryOptions.offsetStart = offsetStart;
            $scope.queryOptions.offsetEnd = offsetEnd;
            return updateQuotesData(filterParam);
        };
    });

    $scope.getLoadByOffset = function () {

        return _getLoadByOffset();
    };

    //Code for policy filter -pagination_MSF

    var _getLoadByOffsetForPolicy = _.memoize(function () {
        return function (offsetStart, offsetEnd) {
            $scope.queryOptions.offsetStartForPolicyFilter = offsetStart;
            $scope.queryOptions.offsetEndForPolicyFilter = offsetEnd;
            return updatePolicyFilterData();
        };
    });

    $scope.filterJobs = function (filter, customFilter) {
        $scope.loading = true;
        if (filter) {
            $scope.currentQuickFilter = filter;
        }

        if (customFilter) {
            $scope.customsFilter = customFilter;
            setCustomFilter(customFilter);
            setCustomFilterFieldsForQuickFilter(filter);
        }
        $scope.tableTitle();

        if ($scope.selectedProducerCode) {
            $scope.filteredJobs = $filter('filter')($scope.allJobs, filterJobByProducerCode);
            setNumberOfOpenJobs($scope.filteredJobs);
            $scope.$broadcast('customFilterSelected'); //Added to update pagination
        }

        $scope.filteredJobs = $filter('filter')($scope.filteredJobs, filterJobByLineOfBusiness);

        setActiveQuickFilter();
        $scope.filteredJobs = $filter('filter')($scope.filteredJobs, filterJob);

        if ($scope.filteredJobs && $scope.customFilter) {
            if ($scope.customFilter.filter === $scope.quoteFilter) {
                $scope.numberOfOpenQuotes = $scope.filteredJobs.length;
            } else if ($scope.customFilter.filter === $scope.renewalFilter) {
                $scope.numberOfOpenRenewals = $scope.filteredJobs.length;
            } else if ($scope.customFilter.filter === $scope.policyChangeFilter) {
                $scope.numberOfOpenPolicyChanges = $scope.filteredJobs.length;
            } else if ($scope.customFilter.filter === $scope.cancellationFilter) {
                //$scope.numberOfOpenCancellations = $scope.filteredJobs.length;
            }
        }
        $scope.loading = false;
    };

    /**
     * Filter a job based on the custom filter options
     * @param {Object} job
     * @returns {boolean} true if the job should be visible, other false
     */
    function filterJob(job) {
        if (!angular.isDefined($scope.customFilter.filter) || $scope.customFilter.filter === null) {
            return true;
        } else if ($scope.customFilter.filter === $scope.recentlyIssuedFilter) {
            return angular.isDefined(job.policy) && job.policy.issued && moment(job.policy.issueDate).isAfter(moment().subtract(30, 'days'));
        } else if ($scope.customFilter.filter === $scope.quoteFilter) {
            return job.type.toLowerCase() === 'submission' && (!checkFilterHasOptionsSelected($scope.customFilter.filter) || filterByOptionDisplayValue($scope.quoteStatusFilter, job.status));
        } else if ($scope.customFilter.filter === $scope.renewalFilter) {
            return job.type.toLowerCase() === 'renewal' && (!checkFilterHasOptionsSelected($scope.customFilter.filter) || filterByOptionDisplayValue($scope.renewalStatusFilter, job.status));
        } else if ($scope.customFilter.filter === $scope.policyChangeFilter) {
            return job.type.toLowerCase() === 'policychange' && (!checkFilterHasOptionsSelected($scope.customFilter.filter) || filterByOptionDisplayValue($scope.policyChangeStatusFilter, job.status));
        } else if ($scope.customFilter.filter === $scope.cancellationFilter) {
            return job.type.toLowerCase() === 'cancellation' && (!checkFilterHasOptionsSelected($scope.customFilter.filter) || filterByOptionDisplayValue($scope.cancellationStatusFilter, job.status));
        }

        return false;
    }

    /**
     * Filter an object based on its line of business
     * @param {Object} item
     * @returns {boolean} true if the item contains a line of business in the custom filter, otherwise false
     */
    function filterByLineOfBusiness(item) {
        return !checkFilterHasOptionsSelected($scope.customFilter.lobFilter) || filterByOptionCode($scope.customFilter.lobFilter, item.latestPeriod.policyLines[0].lineOfBusinessCode);
    }

    /**
     * Filter an object based on its line of business
     * @param {Object} item
     * @returns {boolean} true if the item contains a line of business in the custom filter, otherwise false
     */
    function filterJobByLineOfBusiness(item) {
        return !checkFilterHasOptionsSelected($scope.customFilter.lobFilter) || filterByOptionCode($scope.customFilter.lobFilter, item.policyLines[0].lineOfBusinessCode);
    }

    /**
     * Check if the given code is contained in the given filter options
     * @param {Object} subFilter
     * @param {*} codeValue
     * @returns {boolean} true if the filter contains the code, otherwise false
     */
    function filterByOptionCode(subFilter, codeValue) {
        var selectedOptions = _.where(subFilter.options, {
            selected: true
        });

        if (selectedOptions.length === 0) {
            return false;
        }
        return _.where(selectedOptions, {
            code: codeValue
        }).length > 0;
    }

    /**
     * Check if the given code is contained in the given filter options
     * @param {Object} subFilter
     * @param {*} displayValue
     * @returns {boolean} true if the filter contains the displayValue, otherwise false
     */
    function filterByOptionDisplayValue(subFilter, displayValue) {
        var selectedOptions = _.where(subFilter.options, {
            selected: true
        });

        if (selectedOptions.length === 0) {
            return false;
        }
        return _.where(selectedOptions, {
            displayValue: displayValue
        }).length > 0;
    }

    /**
     * Check if the selected producer code is available for the given policy
     * @param {Object} [policy]
     * @returns {*|boolean} true if the producer code is available, otherwise false
     */
    function filterPolicyByProducerCode(policy) {
        return angular.isDefined(policy) && (angular.isDefined(policy.producerCodeOfRecord) && policy.producerCodeOfRecord === $scope.selectedProducerCode.code || angular.isDefined(policy.producerCodeOfService) && policy.producerCodeOfService === $scope.selectedProducerCode.code || $scope.selectedProducerCode.code === 'all' || $scope.selectedProducerCode.code === 'myWork' && policy.createdByMe);
    }

    /**
     * Check if the selected producer code is available for the given job
     * @param {Object} job
     * @returns {*|boolean} true if the producer code is available, otherwise false
     */
    function filterJobByProducerCode(job) {
        return angular.isDefined(job.producerCodeOfRecord) && job.producerCodeOfRecord === $scope.selectedProducerCode.code || angular.isDefined(job.producerCodeOfService) && job.producerCodeOfService === $scope.selectedProducerCode.code || $scope.selectedProducerCode.code === 'all' || $scope.selectedProducerCode.code === 'myWork' && job.createdByMe;
    }

    // OBJECT CREATION FUNCTIONS

    /**
     * Creates policy summary objects from the list of given policies
     * @param {Array} [summaries]
     * @returns {Array} an array of policy summaries
     */
    function getPolicySummaries(summaries) {
        var policies = [];
        if (angular.isDefined(summaries) && summaries.length > 0) {
            summaries.forEach(function (policySummary) {
                if (policySummary !== null && policySummary !== 'undefined') {
                    var policy = {

                        account: {
                            accountNumber: policySummary.accountNumber
                        },
                        accountHolderName: policySummary.accountHolderName,
                        policyNumber: policySummary.policyNumber,
                        latestPeriod: {
                            policyLines: policySummary.policyLines
                        },
                        policyLines: policySummary.policyLines,
                        producerCodeOfRecord: policySummary.producerCodeOfRecord,
                        producerCodeOfService: policySummary.producerCodeOfService,
                        primaryInsuredName: policySummary.primaryInsuredName,
                        effective: policySummary.effective,
                        expiration: policySummary.expiration,
                        cancelled: policySummary.mSF_Cancellation_EXT,
                        isCancelled: policySummary.isCancelled,
                        totalPremium: policySummary.premium,
                        displayStatus: policySummary.displayStatus,
                        delinquent: policySummary.delinquent,
                        canUserView: policySummary.canUserView,
                        createdByMe: policySummary.createdByMe,
                        product: policySummary.product
                    };

                    policies.push(policy);
                    // Create Policy Line filters dynamically
                    policy.policyLines.forEach(function (policyLine) {
                        createPolicyLineFilter(policyLine);
                    });
                    // Create Policy Status sub filters dynamically
                    createPolicyStatusFilter(policy);
                }
            });
        }

        return policies;
    }

    /**
     * Formats the account holder name
     * @param {Object} account
     * @returns {String} the formatted account holder name
     */
    $scope.getAccountHolderName = function (account) {
        if (account.accountHolder.subtype === 'Company') {
            return account.accountHolder.contactName;
        } else if (account.accountHolder.subtype === 'Person') {
            return account.accountHolder.firstName + ' ' + account.accountHolder.lastName;
        }
    };

    /**
     * Creates an array of open jobs from each account in the given account list
     * @param {Array} [accounts]
     * @returns {Array} an array of open jobs from each account
     */
    function getAllJobs(account) {
        var jobs = [];
        $scope.numberOfOpenQuotes = 0;
        $scope.numberOfOpenRenewals = 0;
        $scope.numberOfOpenPolicyChanges = 0;

        jobs = jobs.concat(account.openSubmissions);
        jobs = jobs.concat(account.openRenewals);
        jobs = jobs.concat(account.openPolicyChanges);
        jobs = jobs.concat(account.openCancellations);

        $scope.numberOfOpenQuotes += account.openSubmissions.length;
        $scope.numberOfOpenRenewals += account.openRenewals.length;
        $scope.numberOfOpenPolicyChanges += account.openPolicyChanges.length + 0;

        populateJobFilterOptions($scope.quoteStatusFilter, account.openSubmissions);
        populateJobFilterOptions($scope.renewalStatusFilter, account.openRenewals);
        populateJobFilterOptions($scope.policyChangeStatusFilter, account.openPolicyChanges);
        populateJobFilterOptions($scope.cancellationStatusFilter, account.openCancellations);

        // Create Policy Line filters dynamically
        jobs.forEach(function (job) {
            job.policyLines.forEach(function (policyLine) {
                createPolicyLineFilter(policyLine);
            });
        });

        return jobs;
    }

    // FILTER POPULATION / CREATION FUNCTIONS

    /**
     * Creates a new policy status filter option if it does not already exist
     * @param {Object} policy
     */
    function createPolicyStatusFilter(policy) {
        if (_.where($scope.policyStatusFilter.options, {
            code: policy.displayStatus
        }).length === 0) {
            var newFilter = {
                code: policy.displayStatus,
                displayKey: policy.displayStatus,
                displayValue: policy.displayStatus,
                selected: false
            };
            $scope.policyStatusFilter.options.push(newFilter);
        }
    }

    /**
     * Creates a new line of business filter option if it does not already exist
     * @param {Object} policyLine
     */
    function createPolicyLineFilter(policyLine) {
        if (_.where($scope.policyLinesFilter.options, { code: policyLine.lineOfBusinessCode }).length === 0) {
            var newFilter = {
                code: policyLine.lineOfBusinessCode,
                displayKey: policyLine.lineOfBusinessName,
                displayValue: policyLine.lineOfBusinessName,
                selected: false
            };
            $scope.policyLinesFilter.options.push(newFilter);
        }
    }

    /**
     * Creates a new job status filter option if it does not already exist
     * @param {Object} filter
     * @param {Array} jobs
     */
    function populateJobFilterOptions(filter, jobs) {
        jobs.forEach(function (job) {
            if (_.where(filter.options, {
                displayValue: job.status
            }).length === 0) {
                var newFilter = {
                    code: job.status,
                    displayKey: job.status,
                    displayValue: job.status,
                    selected: false
                };
                filter.options.push(newFilter);
            }
        });
    }

    // WATCHES

    $scope.$watch('selectedProducerCode', function (oldvalue, newvalue) {
        $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
        $scope.filterJobs($scope.currentQuickFilter, $scope.customFilter.filter);
        if (oldvalue != newvalue && angular.isDefined($scope.selectedProducerCode)) {
            getAccountJobsSummaryForCurrentUser().then(function (producerSummaries) {
                var obj = _.find(producerSummaries, { producerCode: $scope.selectedProducerCode.code });
                if (obj != undefined) {
                    $scope.numberOfOpenCancellations = obj.openCancellations;
                }
            });
        }
    });

    $scope.$watch('customFilter.filter', function () {
        $scope.callFiltersForCurrentFilterOptions();
    });

    // UTILITY FUNCTIONS

    /**
     * Call PolicyCenter to retrieve recently viewed policies for the current user
     * @returns {Promise} recently viewed policies for the current user
     */
    function getRecentlyViewedPolicies() {
        return PolicyService.getRecentlyViewedPolicies();
    }

    /**
     * Call PolicyCenter to retrieve policies issued in the last x number of days
     * @param {Number} numberOfDays
     * @returns {Promise} policies issued in the last x number of days
     */
    function getRecentlyIssuedPolicies(numberOfDays) {
        return PolicyService.getRecentlyIssuedPolicies(numberOfDays, $scope.queryOptions);
    }

    /**
     * Call PolicyCenter to retrieve policies associated with the current user
     * @returns {Promise} policies associated with the current user
     */
    function getPolicySummariesForCurrentUser(numberOfDays) {

        return PolicyService.getPolicySummariesForCurrentUser(numberOfDays, $scope.queryOptions);
    }

    function getPolicySummariesForCurrentUserForPage() {
        if (allPolicyFilterJobs == 0) {
            allPolicyFilterJobs = PolicyService.getPolicySummariesForCurrentUser();
        }
        return allPolicyFilterJobs;
    }

    /**
     * Call PolicyCenter to retrieve the accounts jobs for the current user
     * @returns {Promise} the accounts jobs for the current user
     */
    function getAccountJobsForCurrentUser(filterParam) {
        if (allAccountJobs == 0 || angular.isDefined(filterParam)) {
            allAccountJobs = AccountService.getAccountJobsForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays, $scope.queryOptions, filterParam);
        }
        return allAccountJobs;
    }

    $scope.searchPolicies = function (filterParam) {
        if (filterParam != undefined && filterParam.length >= 5) {
            $scope.loading = true;
            $scope.filterParamLengthValid = true;
            $scope.showErr = false;
            $scope.filterRequest.searchParam = filterParam;
            var filterResults = SearchService.search($scope.filterRequest);
            $scope.filterResultsPromise = filterResults;

            $q.when(filterResults, function (filterResult) {
                $scope.recentlyIssuedPolicies = getPolicySummaries(filterResult.policies);
                $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
                $scope.filterCompleted = true;
                $scope.loading = false;
            }, function (error) {
                if (error.baseError.data.error) {
                    if (error.baseError.data.error.data.appErrorCode !== 609) {
                        ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                    }
                } else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                }
                $scope.filterCompleted = true;
                $scope.loading = false;
            });
        } else if (filterParam.length != 0 && filterParam.length < 5) {
            $scope.showErr = true;
        } else if (filterParam == undefined || filterParam == '') {
            getRecentlyIssuedPolicies(gatewayParamConfig.policiesCreatedInLastXDays).then(function (policies) {
                $scope.recentlyIssuedPolicies = getPolicySummaries(policies);
                $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
                $scope.recentlyIssuedLoading = false;
                $scope.showErr = false;
            }, function () {
                $scope.recentlyIssuedLoading = false;
                $scope.showErr = false;
            });
        } else {
            $scope.filterRequest.searchParam = filterParam;
            $scope.filterResultsPromise = [];
            $scope.filterCompleted = true;
            $scope.filterParamLengthValid = false;
            $scope.showErr = false;
        }
    };

    /**
     * Translate the displayKeys of the given items and assign to item's displayValue property
     * @param {Array} items
     */
    function translateObjectDisplayKeys(items) {
        items.forEach(function (item) {
            TranslateService.translate({
                object: item,
                propName: 'displayValue',
                displayKey: item.displayKey,
                scope: $scope
            });
        });
    }

    /**
     * Set the status of the active quick filters
     */
    function setActiveQuickFilter() {
        PolicyLandingUtil.setActiveQuickFilter($scope);
    }

    /**
     * Set the number of open jobs for each job type in the given list
     * @param {Array} jobs
     */
    function setNumberOfOpenJobs(jobs) {
        PolicyLandingUtil.setNumberOfOpenJobs($scope, jobs);
    }

    /**
     * Set the custom filter sub options to true for the current quick filter
     * @param {Object} filter
     */
    function setCustomFilterFieldsForQuickFilter(filter) {
        PolicyLandingUtil.setCustomFilterFieldsForQuickFilter($scope, $scope.customFilter, filter);
    }

    /**
     * Change the filter options when switching from quick to advanced filters
     * @param {*} shouldShow
     */
    $scope.switchFilterType = function (shouldShow) {
        $scope.showAdvancedFilter = shouldShow;
        if ($scope.showAdvancedFilter) {
            $scope.previousQuickFilter = $scope.currentQuickFilter;
            $scope.previousCustomFilter = $scope.customFilter.filter;

            $scope.currentQuickFilter = null;
        } else {
            $scope.currentQuickFilter = $scope.previousQuickFilter;
            $scope.customFilter.filter = $scope.previousCustomFilter;
        }

        $scope.callFiltersForCurrentFilterOptions();
    };

    /**
     * Set the custom filter
     * @param {Object} filter
     */
    function setCustomFilter(filter) {
        $scope.customFilter.filter = filter;
    }

    /**
     * Check if the advanced filter sub options should be shown
     * @param {Object} filter
     * @returns {boolean} true if the sub options should be shown, otherwise false
     */
    $scope.showSubOptions = function (filter) {
        var hasOptions = false;

        for (var i = 0; i < filter.filters.length; i++) {
            hasOptions = filter.filters[i].options.length > 0;
            if (hasOptions) {
                break;
            }
        }

        return hasOptions && $scope.customFilter.filter === filter;
    };

    /**
     * Call filter for policies and jobs for the current filter options
     */
    $scope.callFiltersForCurrentFilterOptions = function () {
        if (angular.isDefined($scope.customFilter.filter)) {
            if ($scope.customFilter.filter === $scope.policyFilter) {
                $scope.filterPolicies($scope.currentQuickFilter, $scope.customFilter.filter);
            } else {
                $scope.filterJobs($scope.currentQuickFilter, $scope.customFilter.filter);
            }
        }
    };

    function checkFilterHasOptionsSelected(filter) {
        if (angular.isDefined(filter.filters)) {
            for (var i = 0; i < filter.filters.length; i++) {
                if (PolicyLandingUtil.checkFilterHasOptionsSelected(filter.filters[i])) {
                    return true;
                }
            }
        } else if (angular.isDefined(filter.options)) {
            return PolicyLandingUtil.checkFilterHasOptionsSelected(filter);
        }

        return false;
    }

    $scope.getPolicyTypeIcon = function (policyType) {
        return PolicyLandingUtil.getPolicyTypeIcon(policyType);
    };

    $scope.$watchCollection('[recentlyViewedLoading, recentlyIssuedLoading, jobsLoading]', function () {
        $scope.loadingComplete = !$scope.recentlyViewedLoading && !$scope.recentlyIssuedLoading && !$scope.jobsLoading;
    });

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$window', 'ModalService', 'AccountService', 'PolicyService', 'TranslateService', 'GPA_PC_ENTRY_POINT', 'gatewayParamConfig', '$q', 'SearchService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/PolicyLandingCtrl.js
// module id = 1681
// module chunks = 0